// import ModalForm from "./Form";
import FeesNoticeDetailsDeductionsTableForm from "./FeesNoticeDetailsDeductionsTableForm";
import {
	INVOICE_FEE,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const FeesNoticesDetailsDeductionsTableSchema = {
	components: { FeesNoticeDetailsDeductionsTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: INVOICE_FEE + "?is_deduction=yes&invoice_id=" + this.invoiceRequestId,
			tableId: "fees-notice-details-deductions-table",
			formId: "fees-notice-details-deductions-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name
					}
				},
                {
					title: "UOM",
					type: "custom-html",
					key: "uom_id",
					modifier: (value) => {
						return value.name
					}
				},
                {
					title: "Quantity",
					type: "text",
					key: "qty",
				},
                {
					title: "Unit Price",
					type: "custom-html",
					key: "price",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
                {
					title: "Amount",
					type: "custom-html",
					key: "amount",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "FeesNoticeDetailsDeductionsTable",
				url: INVOICE_FEE + "?is_deduction=yes&invoice_id=" + this.invoiceRequestId,
				showHeader: true,
				enableHighlights: false,
				enableSaveFilter: false,
				enableRowSelect: false,
				columns: [],
				actions: [
                    {
                        title: this.$t("view"),
                        icon: "eye",
                        type: "none",
                        // component: "app-add-modal",
                        component: "fees-notice-details-deductions-table-form",
                        modalId: "fees-notice-details-deductions-table-form",
                    },
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "fees-notice-details-deductions-table-form",
						modalId: "fees-notice-details-deductions-table-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: false,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat('id-ID', {
				style: 'currency',
				currency: 'IDR',
				minimumFractionDigits: 0
			}).format(value);
		}
	},
};
